import { CommonModule } from '@angular/common';
import { Component, ContentChild, TemplateRef } from '@angular/core';

@Component({
  selector: 'app-filter-section-wide',
  templateUrl: './filter-section-wide.component.html',
  styleUrl: './filter-section-wide.component.scss',
  standalone: true,
  imports: [CommonModule],
})
export class FilterSectionWideComponent {
  @ContentChild('topSolo') topSolo!: TemplateRef<any>;
  @ContentChild('secondLevel') secondLevel!: TemplateRef<any>;
  @ContentChild('bottomLeft') bottomLeft!: TemplateRef<any>;
  @ContentChild('bottomRight') bottomRight!: TemplateRef<any>;
  @ContentChild('bottomSolo') bottomSolo!: TemplateRef<any>;
}
